import {BankDataValidationEntry} from "@/models/bank-data-validation.ts"
import {ColumnDef} from "@tanstack/react-table"
import {useEffect, useState} from "react"
import {useDebounce} from "@/hooks/use-debounce"
import {DataTable} from "@/components/data-table.tsx"

interface BankDataValidationDataTableProps {
    columns: ColumnDef<BankDataValidationEntry, any>[]
    data: BankDataValidationEntry[]
    searchTerm?: string
}

export function BankDataValidationDataTable({columns, data, searchTerm = ""}: BankDataValidationDataTableProps) {
    const [filteredData, setFilteredData] = useState<BankDataValidationEntry[]>(data)

    const debouncedSearchTerm = useDebounce(searchTerm, 300)

    useEffect(() => {
            if (!debouncedSearchTerm.trim()) {
                setFilteredData(data)
                return
            }

            const filtered = data.filter(entry => {
                const searchLower = debouncedSearchTerm.toLowerCase()

                const memberNoMatch = entry.memberNo.toString().includes(debouncedSearchTerm)
                const nameMatch = `${entry.firstName} ${entry.lastName}`
                    .toLowerCase()
                    .includes(searchLower)

                return memberNoMatch || nameMatch
            })

            setFilteredData(filtered)
        }, [debouncedSearchTerm, data]
    )

    return (
        <div className="space-y-4">
            <DataTable
                columns={columns}
                data={filteredData}
                resetPageKey={debouncedSearchTerm}
                data-testid="bank-data-validation-table"
            />
        </div>
    )
}
